module.exports = __webpack_public_path__ + "static/persona2-thumb-d8d798ce5422c87d528354551c55cfef.png";